export const LOAD_EXAMPLES_DATA = "LOAD_EXAMPLES_DATA"
export const LOAD_EXAMPLES_DATA_SUCCESS = "LOAD_EXAMPLES_DATA_SUCCESS"
export const LOAD_EXAMPLES_DATA_ERROR = "LOAD_EXAMPLES_DATA_ERROR"
export const STORE_NOTES = "STORE_NOTES"
export const SAVE_NOTES = "SAVE_NOTES"
export const REMOVE_NOTE = "REMOVE_NOTE"
